import { render, staticRenderFns } from "./BuyThirdGoods3.vue?vue&type=template&id=5fff6e72&scoped=true&"
import script from "./BuyThirdGoods3.vue?vue&type=script&lang=js&"
export * from "./BuyThirdGoods3.vue?vue&type=script&lang=js&"
import style0 from "./BuyThirdGoods3.vue?vue&type=style&index=0&id=5fff6e72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff6e72",
  null
  
)

export default component.exports